import React from 'react'

function SongTitle() {
  
  return (
    <p id={`song-title`}>Mashup</p>
  )
}

export default SongTitle